import React from 'react';
import PropTypes from 'prop-types';
import Form from './../../Form';
import Loading from './../../Loading';
import Icon from '../../Icon/Icon';

class BetLimitSettingsForm extends Form {
  static propTypes = {};

  static fieldsValidation = {
      hvcStakeBoostPercent: ['numeric', ['range', { start: 0, end: 1000 }]],
      spStakeBoostPercent: ['numeric', ['range', { start: 0, end: 1000 }]],
      minLineStake: [
          'decimal',
          ['range', { start: 0, end: 999999.99 }]
      ],
      minTotalStake: [
          'decimal',
          ['range', { start: 0, end: 999999.99 }]
      ],
      defaultSpPrice: [
          'fractional',
          ['fractionalRange', { start: '1/1000', end: '1000/1' }]
      ],
      maxPayout: [
          'decimal',
          ['range', { start: 0, end: 100000000.0 }]
      ],
      'defaultRabBetLimits.maxBet': [
          'decimal',
          ['range', { start: 0, end: 100000000.0 }]
      ],
      'defaultRabBetLimits.maxWin': [
          'decimal',
          ['range', { start: 0, end: 100000000.0 }]
      ],
      defaultBetBuilderDelay: ['numeric', ['range', { start: 0, end: 999999 }]]
  };

  componentDidMount() {
      this.props.onGetBetLimitSettings();
  }

  UNSAFE_componentWillReceiveProps(props) {
      if (props.data !== this.props.data && status !== 'IN_PROGRESS') {
          this.setState({
              data: props.data
          });
      }

      Form.prototype.UNSAFE_componentWillReceiveProps.apply(this, arguments);
  }

  onSubmit(event) {
      event.preventDefault();

      const { data } = this.state;

      Form.prototype.onSubmit.call(this, event);

      if (!this.isValid()) {
          return false;
      }

      this.props.onPutBetLimitSettings(data);
  }

  renderForm() {
      return (
          <div className='bet-limit-settings-form'>
              <Loading
                  active={this.props.status === 'IN_PROGRESS'}
                  message='Loading Bet limit settings ...'
              />
              <div className='row'>
                  <div className='col-4'>
                      <div className='error-message-below'>
                          {this.getField(
                              <input
                                  type='text'
                                  label='Max bet return'
                                  {...this.getFieldParameters('maxPayout')}
                              />
                          )}
                      </div>
                      <div className='checkbox'>
                          {this.getCheckbox(
                              'acceptBetsWhereReturnExceedMaxBetReturn',
                              'Accept bets where returns exceed max bet return'
                          )}
                          <span title='Accept bets where returns exceed max bet return. Singles and straight accumulators only that are not each way'>
                              <Icon name='info' />
                          </span>
                      </div>
                      <div className='checkbox'>
                          {this.getCheckbox('roundUpMaxStake', 'Round up max stake')}
                          <span title='Round up the maximum allowed bet by a customer to the nearest £1'>
                              <Icon name='info' />
                          </span>
                      </div>
                      <div className='checkbox'>
                          {this.getCheckbox(
                              'allowCustomerBetWhenReturnExceedMaxBetReturn',
                              'Allow Customer to place bet when max bet is exceed'
                          )}
                          <span title='Allow customers to place bet when max bet is exceed'>
                              <Icon name='info' />
                          </span>
                      </div>
                      <div className='row'>
                          <div className='col-6'>
                              {this.getField(
                                  <input
                                      type='text'
                                      label='Minimum line stake'
                                      {...this.getFieldParameters('minLineStake')}
                                  />
                              )}
                          </div>
                          <div className='col-6'>
                              {this.getField(
                                  <input
                                      type='text'
                                      label='Minimum total stake'
                                      {...this.getFieldParameters('minTotalStake')}
                                  />
                              )}
                          </div>
                      </div>
                      <div className='row'>
                          <div className='col-6'>
                              {this.getField(
                                  <input
                                      type='text'
                                      label='Default SP price'
                                      {...this.getFieldParameters('defaultSpPrice')}
                                  />
                              )}
                          </div>
                      </div>
                      <div className='row'>
                          <div className='col-6'>
                              {this.getField(
                                  <input
                                      type='numeric'
                                      label='SP stake boost %'
                                      {...this.getFieldParameters('spStakeBoostPercent')}
                                  />
                              )}
                          </div>
                          <div className='col-6'>
                              {this.getField(
                                  <input
                                      type='numeric'
                                      label='HVC stake boost %'
                                      {...this.getFieldParameters('hvcStakeBoostPercent')}
                                  />
                              )}
                          </div>
                      </div>
                      {this.props.shouldShowRABInputs ? (
                          <>
                              <h4>Build-a-Bet</h4>
                              <div className='row'>
                                  <div className='col-6'>
                                      {this.getField(
                                          <input
                                              type='text'
                                              label='Max bet'
                                              {...this.getFieldParameters(
                                                  'defaultRabBetLimits.maxBet'
                                              )}
                                          />
                                      )}
                                  </div>
                                  <div className='col-6'>
                                      {this.getField(
                                          <input
                                              type='text'
                                              label='Max win'
                                              {...this.getFieldParameters(
                                                  'defaultRabBetLimits.maxWin'
                                              )}
                                          />
                                      )}
                                  </div>
                              </div>
                              <div className='row'>
                                  <div className='col-6'>
                                      {this.getField(
                                          <input
                                              type='numeric'
                                              label='In play bet delay (seconds)'
                                              {...this.getFieldParameters('defaultBetBuilderDelay')}
                                          />
                                      )}
                                  </div>
                              </div>
                          </>
                      ) : null}
                  </div>
              </div>
              <div className='buttons'>
                  <button className='btn btn-primary' type='submit'>
                    Save
                  </button>
              </div>
          </div>
      );
  }
}
export default BetLimitSettingsForm;
